export default __webpack_public_path__ + "static/media/Reshma_Saujani_AHV_In_Moms_We_Trust.475b01f5.jpg";